import Table from '../Utils/Grid';
import React, { Component } from 'react';
import { BreakLineCenter, BreakLine } from '../Utils/tableOptions';
import HeaderSimple from '../Utils/Header/HeaderSimple';
import ToolbarSimple from '../Utils/Toolbar/ToolbarSimple';
import { activeFormatter }  from '../Utils/Acciones/Acciones';
import { Link } from 'react-router-dom';

class PatientHistory extends Component {
    componentWillMount() {
        const patientId = this.props.match.params.id
        this.props.getPatientHistory(patientId)
    }
    componentWillUnmount() {
        //this.props.resetStore();
    }
 
    render() {
      const { patient_history } = this.props;
      /*
        const {
            listar,
            detail,
            create,
            update,
            destroy,
        } = this.props;

        const {
            cargando,
            page,
            data
        } = this.props;
      */
        return (
            <div className="content">
              <div
                className="table-decoration"
                style={{
                  padding: '12px',
                  paddingLeft: '24px'
                }}
              >
                <h5>
                  <center style={{ fontSize: '15px'}} >
                    Historial del paciente
                    <br />
                    <span style={{ fontSize: '15px', fontWeight: 'bold' }}>
                      {patient_history && patient_history.length > 0 && patient_history[0].patient}
                    </span>
                  </center>
                </h5>
                <br />

                {patient_history && patient_history.map(item => {
                  const colorLabel = item.appointment_type.toLowerCase() == 'consulta' ? '#73F527' : item.appointment_type.toLowerCase() == 'quirófano' ? '#27B4F5' : '#DEDEDE';

                  return(
                    <div
                      style={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        paddingInline: '12px',
                        fontSize: '12px',
                        border: 'dotted 1px gray',
                        borderRadius: '8px',
                        marginBottom: '16px',
                        width: '400px',
                        position: 'relative',
                        padding: '8px'                        
                      }}>
                      <div style={{ display: 'flex', flexDirection: 'row'}}>
                        <strong style={{ width: '75px', textTransform: 'capitalize' }}>Fecha: &nbsp;</strong>
                        <label style={{ fontSize: '12px', color: '#000' }}>{item.date.split('-').reverse().join('-')}</label>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'row', position: 'absolute', right: 0, top: 0}}>                        
                          <Link                                         
                            target='_blank'
                            to={`/reporte-consultas/${item.id}`}                            
                          >
                            <label 
                          style={{
                            fontSize: '12px',
                            color: '#000',
                            borderTopRightRadius: '8px',
                            borderBottomLeftRadius: '8px',
                            backgroundColor: colorLabel,
                            textTransform: 'capitalize',
                            padding: '4px 8px',
                            cursor: 'pointer'                            
                          }}
                        >{item.appointment_type}</label>
                            
                          </Link>                         
                      </div>

                      {/*item.appointment_igss_form && <label style={{ fontSize: '12px', color: '#000', backgroundColor: '#87B2FF', textTransform: 'capitalize', marginLeft: '10px', padding: '2px 4px' }}>IGSS</label>*/}

                      <div style={{ display: 'flex', flexDirection: 'row'}}>
                        <strong style={{ width: '75px', textTransform: 'capitalize' }}>Doctor: &nbsp;</strong>
                        <label style={{ fontSize: '12px', color: '#000', fontStyle: 'italic' }}>{item.doctor}</label>
                      </div>

                      {item.appointment_igss_form && 
                        <div style={{ fontSize: '10px', display: 'flex', flexDirection: 'column', color: '#000' }}>
                          <label style={{ fontSize: '10px', fontWeight: 'bold', marginBottom: '0px' }}>                            
                              Información Igss                              
                          </label>                          
                          <div>
                            <Link
                              target='_blank'
                              to={`/igss-forms/${item.note}/view`}>
                                {item.appointment_igss_form}
                            </Link>
                            </div>
                        </div>
                      }
                    </div>
                  );
                })}
              </div>              
            </div>
        )
    }
}

export default PatientHistory;